import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Tooltip from '../Tooltip';

const DataRow = ({
  className,
  label,
  content,
  children,
  tooltipContent
}: {
  className?: string;
  label: string | React.ReactNode;
  content?: string | React.ReactNode;
  children?: React.ReactNode;
  tooltipContent?: string;
}) => {
  return (
    <div
      className={
        className || 'group/row py-1 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-1 items-center'
      }>
      {tooltipContent ? (
        <dt className="font-semibold break-word">
          <Tooltip tooltipContent={tooltipContent}>
            {label}
            <FontAwesomeIcon icon={faQuestionCircle} className="ml-2" />
          </Tooltip>
        </dt>
      ) : (
        <dt className="font-semibold">{label}</dt>
      )}
      <dd className="col-span-3">{children ? children : content}</dd>
    </div>
  );
};
export default React.memo(DataRow);
